export default __webpack_public_path__ + "static/media/rackham.1031a7ce.jpg";